<template>
    <chat-modal v-if="chatType === 'chat-float'" :panelWidth="panelWidth">
        <div class="app-chat container-fluid chat w-100 h-100" :class="chatType === 'chat-float' ? 'shadow' : ''">
            <div class="row h-100">
                <discussions v-show="!chat.id || coexist" @openDiscussion="openDiscussion" />
                <discussion v-if="chat.id" @closeDiscussion="closeDiscussion" />
            </div>
        </div>
    </chat-modal>
    <div v-else>
        <div class="app-chat container-fluid chat" :class="chatType === 'chat-float' ? 'shadow' : ''">
            <div class="row h-100">
                <discussions v-show="!chat.id" @openDiscussion="openDiscussion" />
                <discussion v-if="chat.id" @closeDiscussion="closeDiscussion" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ChatInterface',
  data () {
    return {
      panelWidth: 300
    }
  },
  computed: {
    ...mapState({
      chatOpen: state => state.chatOpen,
      chatType: state => state.chatType,
      chat: state => state.chatActive
    }),
    coexist () {
      return false
      // return window.outerWidth > 768
    }
  },
  methods: {
    ...mapMutations([
      'chatActive'
    ]),
    openDiscussion (discussion) {
      this.chatActive(discussion)
      if (this.coexist) {
        this.panelWidth = 700
      }
    },
    closeDiscussion () {
      this.chatActive({ id: null })
    }
  }
}
</script>

<style lang="scss">

    .chat-fixed {

        .app-chat {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            top: 50px;
        }
    }

    .app-chat {

        &.chat-closed {
            display: none;
        }

        &.chat-fixed, &.chat-float {
            position: fixed;
            top: 50px;
            left: 0;
            right: 0;
            bottom: 50px;
            z-index: 1000;
        }

        .card-footer {
            font-size: 0.65rem;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
        }

        .user-icon {

            img {
                width: 32px;
                height: 32px;
                border-radius: 16px;
            }
        }

        #discussion-nav {

            .nav-link {
                cursor: pointer;

                &.active {
                    position: relative;

                    &:after {
                        content: " ";
                        display: block;
                        position: absolute;
                        height: 2px;
                        width: 40px;
                        left: 50%;
                        bottom: 0;
                        transform: translateX(-50%);
                        background: var(--red);
                    }
                }
            }
        }
    }

    @media (min-width: 768px) {
        .chat-fixed {

            .app-chat {
                width: 300px;
                left: auto;
                right: 0;
            }
        }
    }

    @media (min-width: 1200px) {
        .chat-fixed {

            .app-chat {
                width: 500px;
            }
        }
    }
</style>
